// Module
var code = `<section>
  <div class="actions">
    <div class="filters">
      <div class="labelled-field">
        <label for="disposition-selected-date">Uploaded on</label>
        <date id="disposition-selected-date"
              ng-required="true"
              ng-model="\$ctrl.selectedDate"
              class="labelled-field labelled-field--long"></date>
      </div>
      <button ng-click="\$ctrl.filter()" class="btn btn-primary">
        Filter
      </button>
    </div>
  </div>
  <div class="tab-content">
    <table class="table" ng-table="\$ctrl.tableConfig">
      <thead>
        <tr>
          <th>Uploaded on</th>
          <th>File name</th>
          <th>Clearing file format</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in \$data">
          <td>{{ item.uploadedOn | prettyDateTime }}</td>
          <td>{{ item.fileName }}</td>
          <td>{{ item.parserFormat | prettyEnum }}</td>
          <td>
            <button
              class="btn btn-primary"
              ng-click="\$ctrl.download(item)">
              Download
            </button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-clearing-page/disposition/dispositions.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;